import './time-remaining.scss'

export default class TimeRemaining {
  constructor(container) {
    this.cookieName = 'show_time_remaining'
    this.spacer = container.find('.JS-TimeRemaining-spacer')
    this.widget = container.find('.JS-TimeRemaining-widget')

    let showWidgetCookie = window.Cookies.get(this.cookieName)

    if (showWidgetCookie === undefined || !showWidgetCookie) {
      this.showWidget()
    }

    this.widget.find('.JS-TimeRemaining-close').on('click', (e) => {
      e.preventDefault()
      this.closeWidget()
    })

    let $allDone = this.widget.find('.time-remaining-widget__code-is-set-up')
    $allDone.on('click', (e) => {
      e.preventDefault()
      this.closeWidget()
      if ($allDone.data('info')) {
        window.alert($allDone.data('info'))
      }
    })

    this.widget.find('.dropdown').dropdown()
  }

  showWidget() {
    this.widget.removeClass('time-remaining-widget__hidden')
    this.spacer.removeClass('time-remaining-widget__hidden')
    setTimeout(() => this.setSpacerHeight(), 0)
  }

  setSpacerHeight() {
    this.spacer.height(this.widget.height()).removeClass('time-remaining-widget__hidden')
  }

  closeWidget() {
    this.widget.addClass('time-remaining-widget__hidden')
    this.spacer.addClass('time-remaining-widget__hidden')
    this.saveToCookies()
  }

  saveToCookies() {
    window.Cookies.set(this.cookieName, true, { expires: 365 })
  }
}
